export const PORT = 1000;
export const API_URL_BASE = "";
export const API_CLIENTS_PATH = "/apiclients";
export const CALL_FORWARDINGS_PATH = "/callforwardings";
export const CONTACTS_PATH = "/contacts";
export const APP_STATUSES_PATH = "/app-statuses";
